/**
 * «Підпишись на засновника» — картка з Instagram засновника (owner 2026-10-19).
 * Стоїть під кожною статтею бази знань і під уроками категорії
 * «Від засновника inFLOW». Один рядок, без обіцянки тижня підписки.
 */
import { Icon } from "@/components/Icon";
import { Section } from "@/components/Section";
import { tg } from "@/lib/telegram";

export const FOUNDER_INSTAGRAM_URL = "https://instagram.com/its_yehor";

/** Назва категорії уроків засновника — та сама, що в `LESSON_CATEGORIES`
 *  (`src/inflow/services/knowledge_base.py`). */
export const FOUNDER_LESSONS_LABEL = "Від засновника inFLOW";

export function FounderInstagramCard() {
  const open = () => {
    const webapp = tg();
    if (webapp?.openLink) webapp.openLink(FOUNDER_INSTAGRAM_URL);
    else window.open(FOUNDER_INSTAGRAM_URL, "_blank", "noopener");
  };

  return (
    <Section bodyClassName="p-0">
      <button
        type="button"
        onClick={open}
        className="flex w-full items-center gap-3 p-4 text-left"
      >
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[12px] bg-primary/10 text-primary">
          <Icon name="instagram" size={20} />
        </span>
        {/* Без стрілки праворуч: зі стрілкою фраза не влазила в рядок і
            обрізалась трикрапкою (21.10, заміряно: 257 px тексту на 240 px). */}
        <span className="min-w-0 flex-1 truncate font-display text-[0.9375rem] font-bold text-ink">
          Підпишись на засновника
        </span>
      </button>
    </Section>
  );
}
